import axios from 'axios';
import {api} from '../constants/api';
import {errors as E} from 'common/constants/errors';

export const preRegister = userEmail => dispatch => {
  const data = {userEmail};

  return axios.post(api.PRE_REGISTER, data)
    .then(response => {
      const {errorCode} = response.data;
      if (errorCode < 0) throw new Error(E.EMAIL_IS_NOT_ALLOWED);
    })
};
